import { useState } from "react";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Button,
} from "@mui/material";
import styles from "./memberStatus.module.scss"

const MemberStatus = ({ download, onClose, reportMetadata }) => {
    const [status,setStatus] = useState('all');

    const onChange = (e) => {
        setStatus(e.target.value);
    }

    const onClickDownload = () => {
        const url = `${reportMetadata.url}?status=${status}`;
        download(url, reportMetadata.fileName);
        onClose();
    }

  return (
    <div className={styles.container}>
      <h4>Seleccione un estatus</h4>
      <FormControl>
        <FormLabel id="radio-buttons-group-label-status">Estado</FormLabel>
        <RadioGroup
          row
          aria-labelledby="radio-buttons-group-label-status"
          name="row-radio-buttons-group"
          value={status}
          onChange={onChange}
        >
          <FormControlLabel
           
            control={<Radio />}
            label="Todos (No incluye fallecidos)"
          />
          <FormControlLabel
            value="active"
            control={<Radio />}
            label="Activos"
          />
          <FormControlLabel
            value="inactive"
            control={<Radio />}
            label="Inactivos"
          />
          <FormControlLabel
            value="deceased"
            control={<Radio />}
            label="Fallecidos"
          />
        </RadioGroup>
      </FormControl>
      <div className={styles.btnContainer}>
      <Button variant="contained" onClick={onClickDownload}>Descargar</Button>
      <Button variant="outlined" onClick={onClose}>Cancelar</Button>
      </div>
    </div>
  );
};

export default MemberStatus;
